import { FiCreditCard as CreditCard } from "react-icons/fi";
export const CreditVoucherDetailsHeader = () => {
  return (
    <div className="flex items-center justify-between p-6 border-b border-gray-200">
      <div className="flex items-center space-x-3">
        <CreditCard className="w-10 h-10 text-blue-600" />
        <h2 className="text-xl font-semibold text-gray-900">Credit Voucher Details</h2>
      </div>
    </div>
  );
};
